import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  /* Behavior Subjects */
  private onVpnSource = new BehaviorSubject<boolean>(false);
  private loggedInSource = new BehaviorSubject<boolean>(false);
  private toggleTableSource = new BehaviorSubject<boolean>(false);
  private togglePrintSource = new BehaviorSubject<boolean>(false);
  // Modal submission feedback
  private submittedRecordSource = new BehaviorSubject<any>(null);
  private actionTypeSource = new BehaviorSubject<any>(null);

  /* Observables */
  onVpn = this.onVpnSource.asObservable();
  loggedIn = this.loggedInSource.asObservable();
  toggleTable = this.toggleTableSource.asObservable();
  togglePrint = this.togglePrintSource.asObservable();
  // Modal submission feedback
  submittedRecord = this.submittedRecordSource.asObservable();
  actionType = this.actionTypeSource.asObservable();

  constructor(private http: HttpClient) { }

  // Check VPN Status
  // Ping Salmon JSON response
  // TODO: Error handling so those off VPN don't get a console alert
  // checkVpnStatus() {
  //   this.http.get('https://arcgis.intranet.mndnr.dnr.state.mn.us/arcgis/rest/services?f=pjson', { observe: 'response' })
  //     .pipe(first())
  //     .subscribe(resp => {
  //       if (resp.status === 200) {
  //         return this.onVpnSource.next(true);
  //       } else {
  //         return this.onVpnSource.next(false);
  //       }
  //     },
  //     (error) => {
  //       // throw error;   // Can also throw the error to a global error handler
  //     });
  // }

  // Update logged in status
  loggedInStatus(status: boolean) {
    this.loggedInSource.next(status);
  }

  // Activate the table (triggered from app-map to app-table)
  activateTable(tableActive: boolean) {
    if (tableActive === true) {
      this.toggleTableSource.next(true);
    } else {
      this.toggleTableSource.next(false);
    }
  }

  // Activate the print (triggered from app-map to app-print)
  activatePrint(printActive: boolean) {
    this.togglePrintSource.next(printActive);
  }

  // Update record submission
  updateRecordSubmission(value, submissionType) {
    this.submittedRecordSource.next(value);
    this.actionTypeSource.next(submissionType);
  }

}
